/* eslint-disable indent */
import React, { useState, useMemo, useRef, useCallback, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import {
  Botao,
  BotaoStep,
  IconeCartaoAmex,
  IconeCartaoMaster,
  IconeCartaoVisa,
  ModalRef,
  PdfViewer,
  FormUnform,
  FormRef,
  InputUnform,
  SelectUnform,
  FuncoesMoeda,
  InputMesAnoUnform,
  IconeInformacao,
  Tooltip,
  Cores,
  CartaoCreditoInputUnform,
  focarPrimeiroCampoComErro,
  IconeCartaoElo,
  IconeCartaoHiper,
  IconeCartaoJcb,
  IconeCartaoDiners,
  regExpDiners,
  regExpJcb,
  regExpHiper,
  regExpElo,
  regExpAmex,
  regExpMaster,
  regExpVisa,
  Carregando
} from 'src/componentes'
import {
  SELECT_DIAS_DIAS_BOLETO_AUTOMATICO,
  SELECT_METODOSPAGAMENTO
} from 'src/dados-estaticos'
import { ModalPagamentoCartaoRecorrente } from 'src/paginas/matricula/shared/pagamento-matricula/modal-pagamento-recorrente'
import {
  ContainerBandeiras,
  ContainerBoleto,
  ContainerBotaoAtualizar,
  ContainerBotaoBoleto,
  ContainerBotaoPix,
  IconeLabel,
  LinhaBandeiras
} from 'src/paginas/matricula/shared/pagamento-matricula/styles'
import { RotasAluno } from 'src/rotas/aluno'
import { Api } from 'src/servicos'
import { BoletoGerado, DadosCartao } from 'src/servicos/api/tipos'
import { PagamentoMatricula } from 'src/tipos'

import {
  schemaPagamentoBoleto,
  schemaPagamentoCartaoCredito,
  schemaPagamentoPix
} from '../../../matricula/schema'
import {
  ContainerConteudo,
  ContainerAcoes,
  ContainerCadastro,
  Linha,
  ContainerMedio,
  ContainerInfos,
  Info,
  TituloIsentoRecorrencia,
  ContainerValorTotalCursos
} from '../../../matricula/styles'
import { formatadores } from '../../painel-financeiro/pagina-financeiro/formatadores'
import { ModalPagamentoRequerimento } from '../modal-pagamento-requerimento'

type ParametrosRota = {
  matriculaId: string
}

export const PaginaCertificadoImpressoPagamento: React.FC = () => {
  const modalRef = useRef<ModalRef>(null)
  const modalErroPagRecorrenteRef = useRef<ModalRef>(null)
  const formRef = useRef<FormRef>(null)
  const history = useHistory()
  const { matriculaId } = useParams<ParametrosRota>()

  const [carregandoBoleto, definirCarregandoBoleto] = useState(false)
  const [carregandoFinalizar, definirCarregandoFinalizar] = useState(false)
  const [carregandoVoltar, definirCarregandoVoltar] = useState(false)

  const [metodoPagamento, definirMetedoPagamento] = useState(undefined)

  const [pronto, definirPronto] = useState<boolean>(false)

  const [boleto, definirBoleto] = useState<BoletoGerado | undefined>(undefined)

  const [numeroCartao, definirNumeroCartao] = useState('')

  const [ehPagamentoRecorrente, definirEhPagamentoRecorrente] = useState(false)

  const [pixCopiaECola, definirPixCopiaECola] = useState('')

  const [pdfKey, definirPdfKey] = useState(0)

  const [valorTotal, definirValorTotal] = useState<number>(0)

  const parcelasCartaoCredito = useMemo(() => {
    return Array.from({ length: 12 }, (_, i) => {
      const quantidadeParcelas = i + 1
      const valorParcela = valorTotal / quantidadeParcelas
      return {
        id: `${quantidadeParcelas}`,
        texto: `${quantidadeParcelas}x de ${FuncoesMoeda.formatarMoeda(
          valorParcela
        )}`
      }
    })
  }, [valorTotal])

  const recarregarPdf = () => {
    definirPdfKey(prevKey => prevKey + 1)
  }

  const obterValorTaxaRequerimento = async () => {
    const valor = await Api.ObterValorTaxaRequerimento()
    definirValorTotal(valor.data)
  }

  const obterMatriculaComRequerimento = async () => {
    try {
      definirPronto(false)

      await obterValorTaxaRequerimento()

      await Api.ObterMatriculaComRequerimentoAluno(matriculaId)

      definirPronto(true)
    } catch (error) {
      definirPronto(true)
    }
  }

  const acaoSucesso = async (dados: PagamentoMatricula) => {
    if (metodoPagamento !== SELECT_METODOSPAGAMENTO[0].id) {
      try {
        definirCarregandoBoleto(true)
        let boletoGerado: BoletoGerado

        if (!boleto && metodoPagamento === 'Pix') {
          boletoGerado = await Api.GerarBoletoRequerimento({
            idMatricula: matriculaId,
            diaVencimento: new Date().getDate().toString(),
            cupomId: null,
            pix: 'pix'
          })
        }
        if (!boleto && metodoPagamento === 'Boleto') {
          boletoGerado = await Api.GerarBoletoRequerimento({
            idMatricula: matriculaId,
            diaVencimento: dados.diaVencimento,
            cupomId: null,
            pix: 'pix-e-boleto'
          })
        }

        definirBoleto(boletoGerado)
        const pagamento = {
          ...dados,
          boletoGerado,
          idCupom: null,
          codigoCupom: null,
          valorDesconto: 0,
          valorTotal: valorTotal,
          valor: valorTotal
        }
        // definirPagamento(pagamento)
      } finally {
        definirCarregandoBoleto(false)
      }
    } else {
      try {
        definirCarregandoFinalizar(true)
        const payload = {
          matriculaId: matriculaId,
          cupomId: null,
          dadosCartao: {
            nomeImpresso: dados.nomeCartao,
            numero: dados.numeroCartao.replaceAll(' ', ''),
            validade: dados.validadeCartao,
            codigo: dados.codigoSeguranca,
            parcelas: Number(dados.parcelas ?? 1)
          }
        }

        await Api.AvancarPagamentoRequerimento(payload)
        modalRef?.current?.abrir()

        const pagamento = {
          ...dados,
          idCupom: null,
          codigoCupom: null,
          valorDesconto: 0,
          valorTotal: valorTotal,
          valor: valorTotal
        }
        // definirPagamento(pagamento)
      } finally {
        definirCarregandoFinalizar(false)
      }
    }
  }

  const acaoFinalizar = async () => {
    try {
      if (
        metodoPagamento === SELECT_METODOSPAGAMENTO[1].id ||
        metodoPagamento === SELECT_METODOSPAGAMENTO[2].id ||
        valorTotal < 1
      ) {
        definirCarregandoFinalizar(true)

        const payload = {
          matriculaId: matriculaId,
          cupomId: null
        }

        await Api.AvancarPagamentoRequerimento(payload)

        modalRef?.current?.abrir()
      } else {
        formRef.current?.submitForm()
      }
    } finally {
      definirCarregandoFinalizar(false)
    }
  }

  const getBoletoUrl = (url: string) => {
    const sliceCounter =
      url.indexOf('?formato=') > 0 ? url.indexOf('?formato=') : url.length

    if (metodoPagamento === SELECT_METODOSPAGAMENTO[1].id) {
      return url.slice(0, sliceCounter)
    }

    if (metodoPagamento === SELECT_METODOSPAGAMENTO[2].id) {
      return `${url.slice(0, sliceCounter)}?formato=pix`
    }
  }

  useEffect(() => {
    if (
      boleto &&
      boleto.boletoId &&
      metodoPagamento === SELECT_METODOSPAGAMENTO[2].id
    ) {
      const pegarQrCode = async () => {
        if (boleto.boletoId !== undefined) {
          const resposta = await Api.pegarQrCodeBoleto(boleto.boletoId)
          definirPixCopiaECola(resposta.qrCode)
        }
      }

      pegarQrCode()
    }
  }, [boleto, acaoSucesso])

  useEffect(() => {
    if (pixCopiaECola) {
      definirBoleto(prevBoleto => ({
        ...prevBoleto,
        pixCopiaECola
      }))
    }
  }, [pixCopiaECola])

  useEffect(() => {
    if (metodoPagamento === SELECT_METODOSPAGAMENTO[1].id) {
      const day = new Date(new Date().setDate(new Date().getDate()))
        .getDate()
        .toString()

      formRef.current?.setFieldValue('diaVencimento', day)
    }
  }, [metodoPagamento])

  useEffect(() => {
    obterMatriculaComRequerimento()
  }, [])

  const renderizarBoleto = useCallback(() => {
    if (boleto) {
      return (
        <>
          <Linha>
            <ContainerBoleto>
              {(metodoPagamento === SELECT_METODOSPAGAMENTO[1].id ||
                metodoPagamento === SELECT_METODOSPAGAMENTO[2].id) && (
                <>
                  {metodoPagamento === SELECT_METODOSPAGAMENTO[1].id &&
                    metodoPagamento !== SELECT_METODOSPAGAMENTO[0].id && (
                      <>
                        <h5>
                          Boleto gerado com sucesso!
                          <br />
                          Realize o pagamento do boleto em qualquer banco até a
                          data de vencimento
                        </h5>
                        <p>{boleto.linhaDigitavel}</p>
                        <Botao
                          tema="Link"
                          texto={'Copiar Código do Boleto'}
                          type="button"
                          onClick={() => {
                            navigator.clipboard.writeText(boleto.linhaDigitavel)
                          }}
                        />
                      </>
                    )}
                  {metodoPagamento === SELECT_METODOSPAGAMENTO[2].id &&
                    metodoPagamento !== SELECT_METODOSPAGAMENTO[0].id && (
                      <>
                        {!pixCopiaECola ? (
                          <>
                            <h5>
                              PIX gerado com sucesso!
                              <br />
                              Realize o pagamento via Pix em qualquer banco em
                              até 2 horas
                            </h5>
                            <p>
                              Se o código Copia e Cola ou o QR Code não
                              apareceram para você, espere alguns instantes e
                              clique em atualizar!
                            </p>
                          </>
                        ) : (
                          <>
                            <h5>
                              PIX gerado com sucesso!
                              <br />
                              Realize o pagamento via Pix em qualquer banco em
                              até 2 horas
                            </h5>
                            <p>{pixCopiaECola}</p>
                            <Botao
                              tema="Link"
                              texto={'Copiar Código do PIX'}
                              type="button"
                              onClick={() => {
                                navigator.clipboard.writeText(pixCopiaECola)
                              }}
                            />
                          </>
                        )}
                      </>
                    )}
                </>
              )}
              {!!boleto.linkBoleto && (
                <PdfViewer key={pdfKey} url={getBoletoUrl(boleto.linkBoleto)} />
              )}
            </ContainerBoleto>
          </Linha>
          <ContainerBotaoAtualizar>
            <Botao
              texto="Atualizar"
              tema="Primario"
              type="button"
              onClick={() => {
                recarregarPdf()
              }}
            />
          </ContainerBotaoAtualizar>
        </>
      )
    }
  }, [metodoPagamento, boleto])

  const carregarSeEhPagamentoRecorrente = async () => {
    const pagamentoRecorrente = await Api.ObterSeEhPagamentoRecorrente(null)
    definirEhPagamentoRecorrente(pagamentoRecorrente.pagamentoRecorrente)
    if (pagamentoRecorrente.pagamentoRecorrente) {
      definirMetedoPagamento(SELECT_METODOSPAGAMENTO[0].id)
    }
  }

  const schema = useMemo(() => {
    if (metodoPagamento === SELECT_METODOSPAGAMENTO[0].id) {
      return schemaPagamentoCartaoCredito
    }

    if (metodoPagamento === SELECT_METODOSPAGAMENTO[1].id) {
      return schemaPagamentoBoleto
    }

    if (metodoPagamento === SELECT_METODOSPAGAMENTO[2].id) {
      return schemaPagamentoPix
    }
  }, [metodoPagamento])

  const pagamentoComCartaoDeCredito = async (dadosCartao: DadosCartao) => {
    try {
      await Api.EnviarPagamentoRecorrente(null, dadosCartao)
      history.push(RotasAluno.Requerimentos)
    } catch (erro) {
      toast(
        'Erro ao efetivar pagamento recorrente, informe os dados do cartão novamente',
        { type: 'error' }
      )
      modalErroPagRecorrenteRef?.current?.abrir()
    }
  }

  useEffect(() => {
    carregarSeEhPagamentoRecorrente()
  }, [])

  return (
    <>
      {!pronto ? (
        <Carregando texto="Carregando valores..." />
      ) : (
        <ContainerConteudo>
          <ContainerValorTotalCursos>
            <ContainerInfos>
              <h2>Pagamento de Taxa de Requerimento</h2>
              <Info>
                <h2>Valor Total a Pagar:</h2>
                <h2>
                  <b>{formatadores.moeda(valorTotal)}</b>
                </h2>
              </Info>
            </ContainerInfos>
          </ContainerValorTotalCursos>

          <ContainerCadastro>
            <FormUnform
              ref={formRef}
              schema={schema}
              acaoSucesso={acaoSucesso}
              dadosIniciais={metodoPagamento === SELECT_METODOSPAGAMENTO[2].id}
              acaoFalha={focarPrimeiroCampoComErro}
            >
              {ehPagamentoRecorrente && (
                <TituloIsentoRecorrencia>
                  ISENTO: Não há taxa a pagar por optar pelo pagamento
                  recorrente.
                </TituloIsentoRecorrencia>
              )}

              <>
                <Linha>
                  <ContainerMedio>
                    {valorTotal > 0 && (
                      <SelectUnform
                        id="slc_metodo_pagamento"
                        name="metodoPagamento"
                        label="Selecione a Forma de Pagamento"
                        obrigatorio
                        opcoes={SELECT_METODOSPAGAMENTO}
                        valorAlterado={valor => {
                          definirMetedoPagamento(valor.id)
                          definirNumeroCartao('')

                          formRef.current?.setErrors({})
                        }}
                        disabled={!!boleto}
                      />
                    )}
                    {metodoPagamento === SELECT_METODOSPAGAMENTO[0].id && (
                      <>
                        <LinhaBandeiras>
                          <ContainerBandeiras
                            selecionado={
                              !!numeroCartao.match(regExpVisa) &&
                              !numeroCartao.match(regExpElo)
                            }
                          >
                            {IconeCartaoVisa}
                          </ContainerBandeiras>
                          <ContainerBandeiras
                            selecionado={!!numeroCartao.match(regExpMaster)}
                          >
                            {IconeCartaoMaster}
                          </ContainerBandeiras>
                          <ContainerBandeiras
                            selecionado={!!numeroCartao.match(regExpAmex)}
                          >
                            {IconeCartaoAmex}
                          </ContainerBandeiras>
                          <ContainerBandeiras
                            selecionado={!!numeroCartao.match(regExpElo)}
                          >
                            {IconeCartaoElo}
                          </ContainerBandeiras>
                          <ContainerBandeiras
                            selecionado={!!numeroCartao.match(regExpHiper)}
                          >
                            {IconeCartaoHiper}
                          </ContainerBandeiras>
                          <ContainerBandeiras
                            selecionado={!!numeroCartao.match(regExpJcb)}
                          >
                            {IconeCartaoJcb}
                          </ContainerBandeiras>
                          <ContainerBandeiras
                            selecionado={!!numeroCartao.match(regExpDiners)}
                          >
                            {IconeCartaoDiners}
                          </ContainerBandeiras>
                        </LinhaBandeiras>
                        <CartaoCreditoInputUnform
                          id="ipt_numero_cartao"
                          name="numeroCartao"
                          label="Número do Cartão"
                          obrigatorio
                          onChange={e => {
                            const valor = e.target.value.replaceAll(' ', '')
                            definirNumeroCartao(valor)
                          }}
                        />
                        <InputUnform
                          id="ipt_nome_cartao"
                          name="nomeCartao"
                          label="Nome Conforme Consta no Cartão"
                          obrigatorio
                        />
                        <Linha>
                          <ContainerMedio>
                            <InputMesAnoUnform
                              id="ipt_validade_cartao"
                              name="validadeCartao"
                              label="Validade do Cartão"
                              placeholder="mm/aaaa"
                              formatoAno="AAAA"
                              obrigatorio
                            />
                          </ContainerMedio>
                          <ContainerMedio>
                            <InputUnform
                              id="ipt_codigo_seguranca"
                              name="codigoSeguranca"
                              label={
                                <>
                                  Código de Segurança
                                  <IconeLabel
                                    data-tip="O código de segurança, ou CVV, refere-se ao código de 3 dígitos exibido na frente ou no verso do seu cartão."
                                    data-for="tooltip-cvv"
                                  >
                                    {IconeInformacao}
                                  </IconeLabel>
                                </>
                              }
                              obrigatorio
                              maxLength={4}
                            />
                            <Tooltip
                              id="tooltip-cvv"
                              place="right"
                              className="tooltip-ipgs"
                              textColor={Cores.PRETO}
                              backgroundColor={Cores.CINZA_1_CLARO}
                            />
                          </ContainerMedio>
                        </Linha>
                      </>
                    )}
                  </ContainerMedio>
                  <ContainerMedio>
                    {!ehPagamentoRecorrente && (
                      <>
                        {metodoPagamento === SELECT_METODOSPAGAMENTO[0].id ? (
                          <SelectUnform
                            id="slc_parcelas"
                            name="parcelas"
                            label="Selecione a Quantidade de Parcelas"
                            obrigatorio
                            iconeFechar
                            opcoes={parcelasCartaoCredito}
                          />
                        ) : (
                          <>
                            <Linha>
                              {metodoPagamento && metodoPagamento !== 'Pix' && (
                                <ContainerMedio>
                                  <SelectUnform
                                    id="slc_dia_vencimento"
                                    name="diaVencimento"
                                    label="Dia de Vencimento"
                                    placeholder="Selecione"
                                    obrigatorio
                                    opcoes={SELECT_DIAS_DIAS_BOLETO_AUTOMATICO}
                                    disabled
                                  />
                                </ContainerMedio>
                              )}
                              {!boleto && metodoPagamento === 'Boleto' && (
                                <ContainerBotaoBoleto>
                                  <Botao
                                    texto="Gerar o Boleto"
                                    tema="Secundario"
                                    carregando={carregandoBoleto}
                                  />
                                </ContainerBotaoBoleto>
                              )}
                              {!boleto && metodoPagamento === 'Pix' && (
                                <ContainerBotaoPix>
                                  <Botao
                                    texto="Gerar o Pix"
                                    tema="Secundario"
                                    carregando={carregandoBoleto}
                                  />
                                </ContainerBotaoPix>
                              )}
                              {boleto && (
                                <ContainerBotaoBoleto>
                                  <BotaoStep
                                    texto="Concluir"
                                    tamanho={'S'}
                                    textoNegrito="Requerimento"
                                    type="button"
                                    carregando={carregandoFinalizar}
                                    disabled={
                                      (metodoPagamento ===
                                        SELECT_METODOSPAGAMENTO[1].id ||
                                        metodoPagamento ===
                                          SELECT_METODOSPAGAMENTO[2].id) &&
                                      !boleto
                                    }
                                    onClick={acaoFinalizar}
                                    textoTooltip={
                                      (metodoPagamento ===
                                        SELECT_METODOSPAGAMENTO[1].id ||
                                        metodoPagamento ===
                                          SELECT_METODOSPAGAMENTO[2].id) &&
                                      !boleto
                                        ? 'É necessário realizar a geração do documento para prosseguir com o pagamento'
                                        : undefined
                                    }
                                  />
                                </ContainerBotaoBoleto>
                              )}
                            </Linha>
                          </>
                        )}
                      </>
                    )}
                  </ContainerMedio>
                </Linha>
              </>

              {renderizarBoleto()}
            </FormUnform>
            <ContainerAcoes>
              <BotaoStep
                invertido
                texto="Voltar para"
                textoNegrito="Dados Básicos"
                tema="Secundario"
                disabled={carregandoVoltar}
                onClick={() => {
                  history.goBack()
                }}
              />
              {!boleto && (
                <BotaoStep
                  texto="Concluir"
                  textoNegrito="Requerimento"
                  type="button"
                  carregando={carregandoFinalizar}
                  disabled={
                    (!metodoPagamento ||
                      metodoPagamento === SELECT_METODOSPAGAMENTO[1].id ||
                      metodoPagamento === SELECT_METODOSPAGAMENTO[2].id) &&
                    !boleto
                  }
                  onClick={acaoFinalizar}
                  textoTooltip={
                    (metodoPagamento === SELECT_METODOSPAGAMENTO[1].id ||
                      metodoPagamento === SELECT_METODOSPAGAMENTO[2].id) &&
                    !boleto
                      ? 'É necessário realizar a geração do documento para prosseguir com o pagamento'
                      : undefined
                  }
                />
              )}
            </ContainerAcoes>
          </ContainerCadastro>
        </ContainerConteudo>
      )}
      <ModalPagamentoRequerimento
        ehBoleto={boleto}
        pix={metodoPagamento}
        backdrop
        ref={modalRef}
      />
      <ModalPagamentoCartaoRecorrente
        ref={modalErroPagRecorrenteRef}
        backdrop
        id="modal-pagamento"
        acaoPrimaria={pagamentoComCartaoDeCredito}
      />
    </>
  )
}
